import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './DraftResults.css';

const DraftResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { teamPicks, teamName } = location.state || {};

    const handleStartNewDraft = () => {
        navigate('/');
    };

    return (
        <div className="draft-results-container">
            <h1>Draft Results</h1>
            <h2>{teamName}</h2>
            <div className="results-table">
                {teamPicks && teamPicks.map((pick) => (
                    <div key={pick.pick} className="pick-row">
                        <div className="pick-number">Pick #{pick.pick}</div>
                        <div className="player-info">
                            <span className="player-name">{pick.player.firstName} {pick.player.lastName}</span>
                            <span className="player-details">{pick.player.position} | {pick.player.school}</span>
                        </div>
                    </div>
                ))}
            </div>
            <button className="start-again-button" onClick={handleStartNewDraft}>
                Start Draft Again
            </button>
        </div>
    );
};

export default DraftResults;